import React from 'react';
import { connect } from 'react-redux';
import { 
  Route, 
  Redirect 
} from 'react-router-dom';

/**
 * PrivateRoute
 */
const PrivateRoute = ({ component: Component, auth, ...rest }) => {
  const _checkIfAuthed = () => {
    if (auth.token) {
      return true;
    }
    return false;
  };

  return (
    <Route {...rest} render={props =>
        _checkIfAuthed() === true ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivateRoute);
